import { useQuery } from "@tanstack/react-query";
import { getProductsCategory } from "../../api/apiProducts";
import i18next from "i18next";
import { useParams } from "react-router-dom";

export function useProductsCategory() {
    const { catSlug } = useParams();
    const {
        isLoading,
        data: productsCategory,
        error,
        isFetching
    } = useQuery({
        queryKey: ["categories", catSlug, i18next.language],
        queryFn: () => getProductsCategory(catSlug),
        retry: false,
    });

    return { isLoading, error, productsCategory, isFetching };
}
